import { ref, nextTick, watch } from 'vue';
import { log } from '@/utils/core/vueLogger.js';

// Reusable open/submit lifecycle for a v-dialog wrapping a VStepperForm (@wdns/vuetify-stepper-form):
// tracks dialog visibility, blocks the form's native submit (vee-validate drives @submit instead),
// and wraps the save handler with isSaving guarding + error logging so it always resets, even on an
// early return. See DeliveryLocationForm.vue for a reference usage.
export function useStepperFormDialog(logContext) {
	const isOpen = ref(false);
	const stepperFormWrapper = ref(null);
	const isSaving = ref(false);

	function openDialog() {
		isOpen.value = true;
	}

	function closeDialog() {
		isOpen.value = false;
	}

	async function submit(handler) {
		if (isSaving.value) return;
		isSaving.value = true;
		try {
			await handler();
		} catch (error) {
			log('error', logContext, `❌ Save failed: ${error.message}`);
		} finally {
			isSaving.value = false;
		}
	}

	watch(isOpen, async (open) => {
		if (!open) return;
		await nextTick();
		stepperFormWrapper.value?.$el?.querySelector('form')?.addEventListener('submit', (e) => e.preventDefault());
	});

	return { isOpen, stepperFormWrapper, isSaving, openDialog, closeDialog, submit };
}
